import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {BaseChartDirective} from 'ng2-charts';
import {Chart, ChartOptions, ChartType, registerables} from 'chart.js';

Chart.register(...registerables);

@Component({
  selector: 'pas-chart',
  standalone: true,
  imports: [
    BaseChartDirective,
  ],
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ChartComponent implements OnInit {

  _data!: number[];
  @Input({required: true}) set data (v:number[]) {
    this.pieChartDatasets=[{data: v}];
    this._data = v;
  }
  @Input() title? : string;
  @Input() description? : string

  @ViewChild(BaseChartDirective) baseChart!: BaseChartDirective;

  public refresh(): void {
    this.baseChart.chart?.resize(250,250)
  }

  private cdr = inject(ChangeDetectorRef);

  get total(): number {
    return this._data.reduce((a: number, b: number) => a + b, 0);
  }

  public pieChartDatasets = [{
    data: [70, 20, 10]
  }];
  public readonly pieChartType: ChartType = 'pie';
  public pieChartLabels = ['Красная зона', 'Жёлтая зона', 'Зеленая зона'];


  public pieChartLegend = false;


  public legendColors = ['rgba(228, 33, 48, 1)', 'rgba(250, 175, 64, 1)', 'rgba(0, 156, 65, 1)']

  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context: any) {
            console.log('context',context);
            const overall = context.dataset.data.reduce((a: number, b: number)=> a + b, 0);
            return context.label + ': ' + Math.floor(context.raw / overall * 100).toFixed(0) + '%';
          }
        }
      }
    },
    elements: {
      arc: {
        backgroundColor: this.legendColors,
        borderColor: this.legendColors,
      }
    }
  };

  getDeclensionOrganization = getDeclensionOrganization;


  ngOnInit(): void {

  }
}

export function  getDeclensionOrganization(count: number): string {
  const forms = ["учреждение", "учреждения", "учреждений"];

  // Получаем последнюю цифру и две последние цифры для обработки правил
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return forms[2]; // например, 11, 12, 13, 14 -> "учреждений"
  } else if (lastDigit === 1) {
    return forms[0]; // например, 1, 21, 31 -> "учреждение"
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return forms[1]; // например, 2, 3, 4, 22, 23 -> "учреждения"
  } else {
    return forms[2]; // остальные случаи -> "учреждений"
  }
}
